import React from "react";
import StorageView from "./StorageView";

const Storage = () => {
    return(
        <StorageView />
    );
}

export default Storage;